import { Component,
         OnInit,
         OnDestroy } from '@angular/core'

import { CookieService } from 'src/app/_core/index'


@Component({
  moduleId: module.id,
  selector: 'ss-cookie-consent-page',
  styleUrls: ['cookie-consent-page.component.scss'],
  templateUrl: 'cookie-consent-page.component.html'
})

export class CookieConsentPageComponent implements OnInit, OnDestroy {

  constructor(
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    this.cookieService.updateRequireCookieConsent(false)
  }

  ngOnDestroy() {
    this.cookieService.updateRequireCookieConsent(true)
  }
}
